/**
 * @author liujf
 * @create date 2018-09-04
 * @desc 通用组件全局注册入口文件
 */

import BPConfirm from './BPConfirm/BPConfirm.js'
import BPModal from './BPModal'
import BPInput from './BPInput'
import BPDropdown from './BPDropdown/BPDropdown.vue'
import BPDropdownCasc from './BPDropdown/BPDropdownCasc.vue'
import BPDivider from './BPDivider.vue'
import BPFileUpload from './BPFileUpload.vue'
import BPExpand from './expand.js'
import NumberRangeInput from './SearchCells/NumberRangeInput.vue'
import DateRangePicker from './SearchCells/TimePicker.vue'

import TransferDom from '@/directives/transfer-dom.js'

const components = {
    BPConfirm,
    BPModal,
    BPInput,
    BPDropdown,
    BPDropdownCasc,
    BPDivider,
    BPFileUpload,
    BPExpand,
    NumberRangeInput,
    DateRangePicker
}

const directcives = {
    'bp-transfer-dom': TransferDom
}

const install = (Vue, opts = {}) => { //Vue.use入口
    Object.keys(components).forEach((key) => {
        Vue.component(key, components[key])
    })

    Object.keys(directcives).forEach((key) => {
        Vue.directive(key, directcives[key])
    })

    Vue.prototype.$confirm = BPConfirm
}

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

const bp = {
    version: '1.0.0',
    install,
    ...components
}

export default bp
